import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SensorTypeFormComponent } from '@app/components/forms/sensor-type/form.component';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { SensorType, SensorTypeCreate } from '@app/models/sensor-type.interface';
import { SensorTypeHelperService } from '@app/services/helpers/sensor-type-helper.service';
import { ToastService } from '@app/services/toast.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-sensor-type-edit',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        SensorTypeFormComponent,
        FontAwesomeModule,
        RouterModule,
        HelpButtonComponent
    ],
    templateUrl: './edit.page.html',
    styleUrl: './edit.page.scss'
})
export class SensorTypeEditPage {
  public title = 'Sensor Type Edit';
  formValid = signal(false);
  formValue = signal<SensorTypeCreate | null>(null);
  id: number;
  sensorType$: Observable<SensorType>;

  faSave = faSave;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private sensorTypeHelper: SensorTypeHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.sensorType$ = this.sensorTypeHelper.getById(this.id);
  }

  update() {
    let val = this.formValue();
    if(val)
      this.sensorTypeHelper.update(this.id, val).subscribe({
        next: (success) => { this.router.navigate(['sensor-types', this.id]); },
        error: (err: AppHttpError) => {
          this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
        }
      });
  }
}
